import axios from 'axios';
import pako from 'pako';
import i18n from '../i18n';
import Decimal from "decimal.js";

export function handleError(error, snackbar) {
  //console.log(error);
  if (error.response) {
    // El servidor respondió con un estado diferente de 2xx
    // console.error('Error en la respuesta:', error.response.data.message);
    // console.error('Error en la respuesta: ', error.response.status);
    snackbar('Error en la respuesta: ' + error.response.data.message);
  } else if (error.request) {
    // La solicitud fue hecha pero no se recibió respuesta
    // console.error('No se recibió respuesta: ', error.request);
    snackbar('No se recibió respuesta: ' + error.request);
  } else {
    // Ocurrió un error al configurar la solicitud
    // console.error('Error en la configuración de la solicitud: ', error.message);
    snackbar('Error en la configuración de la solicitud: ' + error.message);
  }
}

export const fetchRegions = async () => {
  const mustDoRequest_ = await mustDoRequest('regions');

  if (mustDoRequest_) {
    try {
      const queryParams = {
        min: '',
        compress: '',
      };
      const response = await axios.get(`${import.meta.env.VITE_API_URL}regions`, { params: queryParams })
      const stringData = compressedBase64ToString(response.data.data);
      localStorage.setItem('regions', stringData);
      return JSON.parse(stringData);
    } catch (error) {
      throw error;
    }
  } else {
    //console.log('cached data');
    return JSON.parse(localStorage.getItem('regions'));
  }
};
export const fetchFiscalTypes = async (country) => {
  try {
    const params = {
      fiscal_types: '',
      country_name: country,
    };
    const response = await axios.get(`${import.meta.env.VITE_API_URL}finance`, { params: params });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
export const fetchFinanceTypesPayments = async () => {
  const mustDoRequest_ = await mustDoRequest('finance_types_payments');
  //console.log(mustDoRequest_);

  if (mustDoRequest_) {
    try {
      const queryParams = {
        payment_types: '',
      };
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}finance`, 
        { params: queryParams, withCredentials: true }
      );
      //console.log(response.data.data);
      localStorage.setItem('finance_types_payments', JSON.stringify(response.data.data));
      return response.data.data;
    } catch (error) {
      throw error;
    }
  } else {
    //console.log('cached data');
    return JSON.parse(localStorage.getItem('finance_types_payments'));
  }
};
export const fetchProducts = async () => {
  const mustDoRequest_ = await mustDoRequest('products');

  if (mustDoRequest_) {
    try {
      const queryParams = {
        min: '',
        compress: '',
      };
      // const response = await axios.get(`${import.meta.env.VITE_API_URL}products`, { params: queryParams }, { withCredentials: true } )
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}products`, 
        { params: queryParams, withCredentials: true },
      );
      const stringData = compressedBase64ToString(response.data.data);
      localStorage.setItem('products', stringData);
      return JSON.parse(stringData);
    } catch (error) {
      throw error;
    }
  } else {
    // console.log('cached data');
    return JSON.parse(localStorage.getItem('products'));
  }
};
export const fetchVetStudies = async () => {
  const mustDoRequest_ = await mustDoRequest(undefined, 'vet_studies');

  if (mustDoRequest_) {
    try {
      const queryParams = {
        min: '',
        compress: '',
      };
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}pets_studies`, 
        { params: queryParams, withCredentials: true },
      );
      const stringData = compressedBase64ToString(response.data.data);
      localStorage.setItem('vet_studies', stringData);
      return JSON.parse(stringData);
    } catch (error) {
      throw error;
    }
  } else {
    //console.log('cached data');
    return JSON.parse(localStorage.getItem('vet_studies'));
  }
};
export const fetchVets = async (searchText, page, user_email) => {
  try {
    const queryParams = {
      for_request: '',
      user_email: user_email,
      search: searchText,
      page: page,
    };
    const response = await axios.get(`${import.meta.env.VITE_API_URL}vets`, { params: queryParams })
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
export const fetchOwner = async (id, updateLastView) => {
  try {
    const queryParams = {
      id: id,      
    };

    if (updateLastView)
      queryParams.update_last_view = 1;

    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}owners`, 
      { params: queryParams, withCredentials: true },
    );
    //console.log(response);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
export const fetchOwners = async () => {
  const mustDoRequest_ = await mustDoRequest('owners');

  if (mustDoRequest_) {
    try {
      const queryParams = {
        min: '',
        compress: '',
      };
      const response = await axios.get(`${import.meta.env.VITE_API_URL}owners`, {params: queryParams, withCredentials: true})
      const stringData = compressedBase64ToString(response.data.data);
      localStorage.setItem('owners', stringData);
      return JSON.parse(stringData);
    } catch (error) {
      throw error;
    }
  } else {
    // console.log('cached owners data');
    return JSON.parse(localStorage.getItem('owners'));
  }
};

export const fetchPet = async (id, updateLastView) => {
  try {
    const queryParams = {
      id: id,      
    };

    if (updateLastView)
      queryParams.update_last_view = 1;

    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}pets`, 
      { params: queryParams, withCredentials: true },
    );
    // console.log(response);    
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
export const fetchSell = async (id) => {
  try {
    const queryParams = {
      id: id,      
    };

    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}sells`, 
      { params: queryParams, withCredentials: true },
    );

    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchPurchase = async (id) => {
  try {
    const queryParams = {
      id: id,      
    };

    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}purchases`, 
      { params: queryParams, withCredentials: true },
    );

    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchMovement = async (id) => {
  try {
    const queryParams = {
      id: id,      
    };

    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}internal_movements`, 
      { params: queryParams, withCredentials: true },
    );

    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchSpending = async (id) => {
  try {
    const queryParams = {
      id: id,      
    };

    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}spendings`, 
      { params: queryParams, withCredentials: true },
    );

    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchCashMovement = async (id) => {
  try {
    const queryParams = {
      id: id,      
    };

    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}cash_movements`, 
      { params: queryParams, withCredentials: true },
    );

    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchClinic = async (id_pet, page) => {
  try {
    const queryParams = {
      id_pet: id_pet,
      page: page,      
    };
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}pets_clinic`, 
      { params: queryParams, withCredentials: true },
    );
    // Return full pagination object to allow callers to manage hasMore
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
export const fetchForInput = async (table, objectName) => {
  const mustDoRequest_ = await mustDoRequest(undefined, objectName);

  if (mustDoRequest_) {
    try {
      const queryParams = {
        for_input: '',
        compress: '',
      };
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}${table}`, 
        { params: queryParams, withCredentials: true },
      );
      //console.log(response);
      
      const stringData = compressedBase64ToString(response.data.data);
      localStorage.setItem(objectName, stringData);
      return JSON.parse(stringData);
    } catch (error) {
      throw error;
    }
  } else {
    // console.log('cached data');
    return JSON.parse(localStorage.getItem(objectName));
  }
};
export const fetchServicesForInput = async () => {
  const mustDoRequest_ = await mustDoRequest(undefined, 'services_for_input');

  if (mustDoRequest_) {
    try {
      const queryParams = {
        services_for_input: '',
        compress: '',
      };
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}products`, 
        { params: queryParams, withCredentials: true },
      );
      //console.log(response);
      
      const stringData = compressedBase64ToString(response.data.data);
      localStorage.setItem('services_for_input', stringData);
      return JSON.parse(stringData);
    } catch (error) {
      throw error;
    }
  } else {
    // console.log('cached data');
    return JSON.parse(localStorage.getItem('services_for_input'));
  }
};

export const fetchById = async (id, endpoint) => {
  try {
    const queryParams = {
      id: id,      
    };

    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}${endpoint}`, 
      { params: queryParams, withCredentials: true },
    );
    //console.log(response);
    
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
export const fetchRecent = async (page, table) => {
  try {
    const queryParams = {
      recent: '',
      page: page,      
    };

    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}${table}`, 
      { params: queryParams, withCredentials: true },
    );
    //console.log(response.data.data.content);
    return response.data.data.content;
  } catch (error) {
    throw error;
  }
};
export const fetch = async (table, params) => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}${table}`, 
      { params: params ? params : null, withCredentials: true },
    );
    // console.log(response.data.data)
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
export const fetchSearchPage = async (table, searchText, page, productsGlobalsInclude = false) => {
  try {
    const params = {
      search: searchText,
      page: page,
      globals_include: productsGlobalsInclude ? 1 : null,
    };
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}${table}`, 
      {params: params, withCredentials: true},
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
export const fetchSearchPageServices = async (table, searchText, page, productsGlobalsInclude = false) => {
  try {
    const params = {
      search: searchText,
      page: page,
      services: '',
    };
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}products`, 
      {params: params, withCredentials: true},
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
export const fetchSearchPageServicesCategories = async (searchText, page) => {
  try {
    const params = {
      search: searchText,
      page: page,
      only_services: '',
      format: 'SEARCH',
    };
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}products_categories`, 
      {params: params, withCredentials: true},
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
export const fetchPetsDashboard = async () => {
  try {
    const queryParams = {
      dashboard: '',
    };

    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}pets`, 
      { params: queryParams, withCredentials: true },
    );
    //console.log(response.data.data);
    
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
export const fetchReport = async (report_type, page, additionalParams = {}) => {
  try {
    const params = {
      type: report_type,
      page: page,
      ...additionalParams
    };
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}reports`, 
      {params: params, withCredentials: true},
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
// export const fetchAgendaReport = async (page, from, to) => {
//   try {
//     const params = {
//       type: 'AGENDA',
//       page: page,
//       from: from,
//       to: to,
//     };
//     console.log(params);
//     const response = await axios.get(
//       `${import.meta.env.VITE_API_URL}reports`, 
//       {params: params, withCredentials: true},
//     );
//     return response.data.data;
//   } catch (error) {
//     throw error;
//   }
// };

const mustDoRequest = async (table_name, object_name) => {
  
  let final_object_name = table_name;
  if (object_name)
    final_object_name = object_name;

  //from server
  const last_update_server = await getLastUpdate(table_name, object_name);
  const last_update_server_date = new Date(last_update_server.replace(' ', 'T'));
  
  //local
  if (localStorage.getItem(`${final_object_name}_last_update`) === null)
    localStorage.setItem(`${final_object_name}_last_update`, last_update_server);

  const last_update_local = localStorage.getItem(`${final_object_name}_last_update`);
  const last_update_local_date = new Date(last_update_local.replace(' ', 'T'));

  //cache file
  const last_update_cache = localStorage.getItem(final_object_name);

  const mustDoRequest = !last_update_cache || (last_update_server_date > last_update_local_date);
  return mustDoRequest;
}
const getLastUpdate = async (table_name, object_name) => {
  try {
    let url = `${import.meta.env.VITE_API_URL}sys_last_update`;
    
    if (table_name)
      url += `?table_name=${table_name}`;

    if (object_name)
      url += `?object_name=${object_name}`;

    const response = await axios.get(
      url,
      { withCredentials: true },
    );
    //console.log(response);
    return response.data.data.update_time;
  } catch (error) {
    throw error;
    // handleError(error);
    // return null;
  }
}
// export const fetchSearchProducts = async (searchText, page, globalsInclude) => {
//   try {
//     const params = {
//       search: searchText,
//       page: page,
//       globals_include: globalsInclude,
//     };
//     const response = await axios.get(
//       `${import.meta.env.VITE_API_URL}products`, 
//       { params: params, withCredentials: true },
//     );
//     return response.data.data;
//   } catch (error) {
//     handleError(error);
//     return null;
//   }
// };


// export const fetchOwnersRecent = async (page) => {
//   try {
//     const queryParams = {
//       recent: '',
//       page: page,      
//     };

//     const response = await axios.get(
//       `${import.meta.env.VITE_API_URL}owners`, 
//       { params: queryParams, withCredentials: true },
//     );
//     //console.log(response.data.data.content);
    
//     return response.data.data.content;
//   } catch (error) {
//     handleError(error);
//     return null;
//   }
// };

export const compressedBase64ToString = (base64string) => {
  const binaryString = atob(base64string); // Decodificar Base64 a binario
  const len = binaryString.length;
  const compressedArray = new Uint8Array(len);
  for (let i = 0; i < len; i++) 
    compressedArray[i] = binaryString.charCodeAt(i);

  const decompressedArray = pako.inflate(compressedArray, { to: 'string' });
  return decompressedArray;
}
export const validateNonEmpty = (fieldName, fieldValue, setErrFunc, fieldRef) => {
  // Convert to string and handle null/undefined
  const strValue = fieldValue == null ? '' : String(fieldValue);
  if (strValue.trim() !== '') {
    setErrFunc({});
    return true;
  }

  let error = {
    [fieldName]: i18n.t('common.errorFieldEmpty')
  };
  setErrFunc(error);
  fieldRef.current.focus();
  fieldRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
  return false;
}
export const validateEmail = (fieldName, fieldValue, setErrFunc, fieldRef, nullPass) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if ( (nullPass && !fieldValue) || (emailRegex.test(fieldValue)) ) {
    setErrFunc({});
    return true;
  }

  let error = {
    [fieldName]: i18n.t('common.errorCorrectField')
  };
  setErrFunc(error);
  fieldRef.current.focus();
  fieldRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
  return false;
}

/** Número local (sin prefijo de país): solo dígitos contados, longitud típica móvil. */
export const isValidLocalPhoneInput = (fieldValue) => {
  const str = fieldValue == null ? '' : String(fieldValue).trim();
  if (str === '') return false;
  const digitsOnly = str.replace(/\D/g, '');
  return digitsOnly.length >= 6 && digitsOnly.length <= 15;
};

export const validatePhone = (fieldName, fieldValue, setErrFunc, fieldRef, nullPass) => {
  const str = fieldValue == null ? '' : String(fieldValue).trim();
  if (nullPass && str === '') {
    setErrFunc({});
    return true;
  }
  if (isValidLocalPhoneInput(fieldValue)) {
    setErrFunc({});
    return true;
  }

  const error = {
    [fieldName]: i18n.t('common.errorCorrectField')
  };
  setErrFunc(error);
  fieldRef.current.focus();
  fieldRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
  return false;
};
export const validatePassword = (fieldName, fieldValue, setErrFunc, fieldRef) => {
  if (fieldValue.length >= 8) {
    setErrFunc({});
    return true;
  }

  let error = {
    [fieldName]: i18n.t('common.errorFieldEmpty')
  };
  setErrFunc(error);
  fieldRef.current.focus();
  fieldRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
  return false;

  // if (!fieldValue || field.length < 8) {
  //   setErrFunc(i18n.t('common.errorFieldEmpty'));
  //   fieldRef.current.focus();
  //   fieldRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
  //   return false;
  // }

  // setErrFunc('');
  // return true;
};
export const validateDecimal = (fieldName, fieldValue, setErrFunc, fieldRef) => {
  const trimmedValue = fieldValue.toString().trim();
  
  // Expresión regular para validar números decimales
  const decimalPattern = /^[+-]?((\d+\.?\d*)|(\.\d+))$/;
  
  if (decimalPattern.test(trimmedValue) && !isNaN(trimmedValue)) {
    setErrFunc({});
    return true;
  }

  const error = {
    [fieldName]: i18n.t('common.errorCorrectField')
  };
  
  setErrFunc(error);
  
  if (fieldRef?.current) {
    fieldRef.current.focus();
    fieldRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  
  return false;
};
  // Validates that at least one owner is selected
export const validateItemSelected = (fieldName, array, setErrFunc, fieldRef) => {
  if (array && array.length > 0) {
    setErrFunc({});
    return true;
  }

  let error = {
    [fieldName]: i18n.t('common.errSelectItem')
  };
  setErrFunc(error);

  fieldRef.current.focus();
  fieldRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
  return false;
};

export const verifyCaptchaToken = async (token) => {
  try {
    const res = await axios.post(`${import.meta.env.VITE_API_URL}users?verify_captcha_web`, { response: token });
    // console.log(res.data.success === true);
    return res.data.success === true;
  } catch (error) {
    throw error;
    // handleError(error);
    // return false;
  }
}
export const formatCurrency = (number) => {
  const currencyFormat = new Intl.NumberFormat(i18n.language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return currencyFormat.format(number);
}
// export const formatDate = (dateString) => {
//   const date = new Date(dateString);
//   return new Intl.DateTimeFormat(i18n.language).format(date);
// };
export const formatDate2 = (dateString) => {
  // Handle both formats: with time (YYYY-MM-DD HH:mm:ss) and without (YYYY-MM-DD)
  const localDate = dateString.includes(' ') ? dateString : `${dateString} 00:00:00`;
  const date = new Date(localDate.replace(' ', 'T'));
  return new Intl.DateTimeFormat(i18n.language).format(date);
};
export const formatDateReplaceHour = (dateString, config) => {
  if (!dateString) return '';
  const str = String(dateString).trim();
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '';
  const hour12 = resolveHour12Preference(config, i18n.language);
  const today = new Date();
  const isToday = date.toDateString() === today.toDateString();

  if (isToday) {
    return new Intl.DateTimeFormat(i18n.language, {
      hour: 'numeric',
      minute: 'numeric',
      hour12,
    }).format(date);
  }

  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(str);
  if (dateOnly) {
    return new Intl.DateTimeFormat(i18n.language).format(date);
  }

  return new Intl.DateTimeFormat(i18n.language, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12,
  }).format(date);
};

export const formatDateLong = (dateString) => {
  // Ensure the date is interpreted in local timezone by appending T00:00:00
  const localDate = dateString.includes('T') ? dateString : `${dateString}T00:00:00`;
  const date = new Date(localDate);
  return new Intl.DateTimeFormat(i18n.language, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);
};
export const formatHour = (dateString, hour12 = false) => {
  const date = new Date(dateString);
  const hour = new Intl.DateTimeFormat(undefined, {
    hour: 'numeric',
    minute: 'numeric',
    hour12: hour12,
  }).format(date);
  return hour;
}
export const formatDateHour = (dateString) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat(i18n.language, {
    dateStyle: 'medium', // Formato para la fecha (short, medium, long o full)
    timeStyle: 'short',  // Formato para la hora (short, medium, long o full)
  }).format(date);
};
export const formatDateHour2 = (mysqlDateString, config) => {
  if (!mysqlDateString) return '';
  const date = new Date(mysqlDateString.replace(" ", "T"));
  const hour12 = resolveHour12Preference(config, i18n.language);

  const formatted = new Intl.DateTimeFormat(i18n.language, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12,
  }).format(date);

  return formatted;
}
export const getSupplyStr = (supplyStr) => {
  if (supplyStr == 'NA')
    return 'Sin suministro';
  else if (supplyStr == 'PENDING')
    return 'Suministro pendiente';
  else if (supplyStr == 'EXPIRED')
    return 'Suministro vencido';
  else
    return 'Suministro pendiente y vencido';
}
export const getReasonStr = (reasonStr) => {
  if (reasonStr == null || reasonStr === '') return '';
  return i18n.t(`visitReasons.${reasonStr}`, { defaultValue: String(reasonStr) });
}

export const capitalizeFirstLetter = (string) => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
} 

export const getFirstPrincipalOwner = (owners) => {
  const principalOwner = owners.find(owner => 
    owner.is_principal !== null && owner.is_principal === 1
  );
  
  if (principalOwner) return principalOwner;
  if (owners.length > 0) return owners[0];
  return null;
};

// Función que retorna la descripción de un producto (incluye cantidad, unidad, precio y descuento/recargo)
export const getDescription = (item) => {
  let unit = item.selected_unit;
  const isComplexUnitDontShowQuantityPerPrice = false;

  if (!unit && item.product && item.product.unit) {
    unit = item.product.unit.is_complex === 1
      ? item.product.unit.second_unit_string
      : item.product.unit.first_unit_string;
  }

  let description = `${item.quantity} ${unit}`;
  
  if (!isComplexUnitDontShowQuantityPerPrice) {
    description += ` x ${formatCurrency(item.price)}`;
  }

  const discount_surcharge = item.discount_surcharge;
  if (discount_surcharge == null) return description;
  if (discount_surcharge > 0) {
    description += ` (x -${discount_surcharge}%)`;
  } else if (discount_surcharge < 0) {
    description += ` (x +${Math.abs(discount_surcharge)}%)`;
  }
  return description;
};

// Calcula el subtotal aplicando descuento/recargo
export const getSubtotal = (quantityValue, priceValue, discountValue) => {
  const quantity = quantityValue != null ? new Decimal(quantityValue) : new Decimal(0);
  let price = priceValue != null ? new Decimal(priceValue) : new Decimal(0);
  const discount = discountValue != null ? new Decimal(discountValue) : new Decimal(0);

  if (!discount.equals(0)) {
    price = price.sub(price.mul(discount).div(100));
  }
  const subtotal = quantity.mul(price);
  return subtotal.toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
};

export const getFileExtension = (filename) => {
  return filename.split('.').pop();
}

export const getFileNameWithoutExtension = (filename) => {
  if (!filename) return '';
  const lastDotIndex = filename.lastIndexOf('.');
  return lastDotIndex === -1 ? filename : filename.substring(0, lastDotIndex);
}

export const removeNulls = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(removeNulls);
  } else if (obj && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([_, value]) => value !== null)
        .map(([key, value]) => [key, removeNulls(value)])
    );
  }
  return obj;
}

export const removeNullsAndEmptys = (obj) => {
  if (Array.isArray(obj)) {
    return obj
      .map(removeNullsAndEmptys)
      .filter((value) => value !== null && value !== '');
  } else if (obj && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([_, value]) => value !== null && value !== '')
        .map(([key, value]) => [key, removeNullsAndEmptys(value)])
    );
  }
  return obj;
}

// export const openCache = async () => {
//   const cache = await caches.open('doctorvet-cache');
//   return cache;
// };
// // Almacenar un archivo en el caché usando su nombre y la URL
// export const cacheResource = async (fileName, url) => {
//   const cache = await openCache();
//   const response = await fetch(url);

//   const cachedResource = {
//     fileName,
//     response,
//   };

//   // Almacenamos el archivo en el cache con el nombre del archivo como clave
//   await cache.put(fileName, new Response(JSON.stringify(cachedResource)));
// };
// export const getResource = async (fileName, url) => {
//   const cache = await openCache();
  
//   const cachedResponse = await cache.match(fileName);

//   if (cachedResponse) {
//     const cachedData = await cachedResponse.json();
//     console.log(cachedData);

//     //return cachedData.response; // Si existe en el caché, lo retornamos
//     return URL.createObjectURL(await cachedData.response.blob());
//   }

//   // Si el archivo no está en caché, lo descargamos desde la URL
//   console.log(url);

//   const response = await axios.get(url, { responseType: 'blob' });
//   console.log(response);

//   //await cacheResource(fileName, url);
//   //return response;
//   //return URL.createObjectURL(await response.blob());
// };

export const formatDateForMySQL = (date) => {
  return date.format('YYYY-MM-DD');
};

export const formatDateTimeForMySQL = (date) => {
  return date.format('YYYY-MM-DD HH:mm:ss');
};

/** BCP 47 locale: vet region (code / country), then browser. */
export const resolveDateFormattingLocale = (config) => {
  const region = config?.vet?.region;
  const code = region?.code;
  if (code && typeof code === 'string') {
    return code.replace(/_/g, '-');
  }
  const cc = region?.country_code;
  if (cc && typeof cc === 'string') {
    const upper = cc.toUpperCase();
    const byCountry = {
      US: 'en-US',
      GB: 'en-GB',
      AR: 'es-AR',
      BR: 'pt-BR',
      MX: 'es-MX',
      ES: 'es-ES',
      PT: 'pt-PT',
      CL: 'es-CL',
      CO: 'es-CO',
      UY: 'es-UY',
      PY: 'es-PY',
      BO: 'es-BO',
      VE: 'es-VE',
      PE: 'es-PE',
      EC: 'es-EC',
      CR: 'es-CR',
      PA: 'es-PA',
      DO: 'es-DO',
      CA: 'en-CA',
      AU: 'en-AU',
      NZ: 'en-NZ',
      DE: 'de-DE',
      FR: 'fr-FR',
      IT: 'it-IT',
      JP: 'ja-JP',
      CN: 'zh-CN',
    };
    if (byCountry[upper]) return byCountry[upper];
  }
  if (typeof navigator !== 'undefined' && navigator.language) {
    return navigator.language;
  }
  return 'es-AR';
};

/** Maps BCP 47 to dayjs locale id for AdapterDayjs (import locales in the page). */
export const bcp47ToDayjsLocale = (bcp47) => {
  const tag = (bcp47 || 'en').toLowerCase();
  if (tag.startsWith('pt-br')) return 'pt-br';
  if (tag.startsWith('pt')) return 'pt';
  if (tag.startsWith('en-gb')) return 'en-gb';
  if (tag.startsWith('en')) return 'en';
  if (tag.startsWith('es')) return 'es';
  if (tag.startsWith('de')) return 'de';
  if (tag.startsWith('fr')) return 'fr';
  if (tag.startsWith('it')) return 'it';
  if (tag.startsWith('ja')) return 'ja';
  if (tag.startsWith('zh')) return 'zh-cn';
  const base = tag.split('-')[0];
  if (base === 'pt') return 'pt';
  if (base === 'es') return 'es';
  return 'en';
};

/**
 * 12h (AM/PM) vs 24h: vet hour_format (AM_PM / 24_HS), then locale.
 * Spanish/Portuguese regions use 24h in forms; US et al. follow Intl hour cycle (h12).
 */
export const resolveHour12Preference = (config, locale) => {
  const hf = config?.vet?.hour_format;
  if (hf === 'AM_PM') return true;
  if (hf === '24_HS') return false;

  const tag = (locale || '').toLowerCase();
  if (tag === 'es' || tag.startsWith('es-') || tag === 'pt' || tag.startsWith('pt-')) {
    return false;
  }

  try {
    const loc = new Intl.Locale(locale);
    const first = loc.hourCycles?.[0];
    return first === 'h12' || first === 'h11';
  } catch (_) {
    return false;
  }
};

const buildDayjsDatePatternFromIntl = (locale, withYear) => {
  const sample = new Date(1999, 0, 2);
  const intl = new Intl.DateTimeFormat(locale, {
    ...(withYear ? { year: 'numeric' } : {}),
    month: '2-digit',
    day: '2-digit',
  });
  let pattern = '';
  for (const part of intl.formatToParts(sample)) {
    if (part.type === 'year') pattern += 'YYYY';
    else if (part.type === 'month') pattern += 'MM';
    else if (part.type === 'day') pattern += 'DD';
    else pattern += part.value;
  }
  return pattern;
};

/** Full date for display (e.g. MM/DD/YYYY vs DD/MM/YYYY) from locale. */
export const getDayjsDateFormatForLocale = (locale) =>
  buildDayjsDatePatternFromIntl(locale, true);

/** Month + day only (e.g. week headers) from locale. */
export const getDayjsMonthDayFormatForLocale = (locale) =>
  buildDayjsDatePatternFromIntl(locale, false);

/**
 * Date for agenda/page titles: full month name (e.g. es “26 de marzo de 2026”, not “26 mar 2026” from medium).
 * Accepts a dayjs instance or any value with .toDate().
 */
export const formatAgendaDateTitle = (dayjsDate, locale) => {
  if (!dayjsDate) return '';
  const d =
    typeof dayjsDate.toDate === 'function'
      ? dayjsDate.toDate()
      : new Date(dayjsDate);
  if (Number.isNaN(d.getTime())) return '';
  try {
    return new Intl.DateTimeFormat(locale || undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(d);
  } catch (_) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
};

/** Dayjs format for MUI DateTimePicker: date order from locale; time 12h or 24h. */
export const getDayjsDateTimeFormatForLocale = (locale, useHour12 = false) => {
  const datePattern = buildDayjsDatePatternFromIntl(locale, true);
  const time = useHour12 ? ' hh:mm A' : ' HH:mm';
  return `${datePattern}${time}`;
};

export const isEditing = (obj) => {
  return obj && obj.id != null && obj.id !== undefined && obj.id !== '';
};

